module.exports = __webpack_public_path__ + "img/high_five.b3ccda85.svg";